import React from 'react';

import { Alert } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { LoginForm } from 'components/login-form/LoginForm';
import { LoginTitle } from 'components/login-layout/LoginTitle';

export type LoginModalProps = {
    afterSubmit?: (email: string, userId: string) => Promise<void>;
    redirect?: string;
    message?: React.ReactNode | string;
    title?: React.ReactNode | string;
    closeModal?: () => void;
    closeOnSubmit?: boolean;
    hideEnterCode?: boolean;
    startWithCode?: boolean;
    notice?: React.ReactNode;
};

const LoginModal = ({ innerProps }: ContextModalProps<LoginModalProps>) => {
    const {
        afterSubmit,
        redirect = window.location.toString().replace(window.location.origin, ''),
        title,
        message,
        closeModal,
        closeOnSubmit,
        hideEnterCode,
        startWithCode,
        notice,
    } = innerProps || {};

    return (
        <>
            <LoginTitle overrideTitle={title} message={message} />

            {notice && (
                <Alert color="green" mb="md">
                    {notice}
                </Alert>
            )}

            <LoginForm
                redirect={redirect}
                afterSubmit={async (email, userId) => {
                    afterSubmit?.(email, userId).then();
                    closeOnSubmit && closeModal?.();
                }}
                afterLogin={closeModal}
                hideEnterCode={hideEnterCode}
                startWithCode={startWithCode}
            />
        </>
    );
};

export { LoginModal };
